import { useTranslation } from 'react-i18next';
import { setCategoryView, useData, type CategoryView } from './dataStore';
import { SHEETS } from './sheet';

const VIEWS: CategoryView[] = ['table', 'sheet'];

/** Table (balancing view) | Sheet, for categories that have a sheet view; remembered per viewer. */
export function ViewSwitch({ category }: { category: string }) {
  const { t } = useTranslation();
  const view = useData((s) => s.views[category]) ?? 'table';
  if (!SHEETS[category]) return null;
  return (
    <div className="view-switch" role="group" aria-label={t('data.sheet.viewLabel')}>
      {VIEWS.map((v) => (
        <button
          key={v}
          className={`small${view === v ? ' active' : ''}`}
          aria-pressed={view === v}
          title={t(`data.sheet.view.${v}Hint`)}
          onClick={() => setCategoryView(category, v)}
        >
          {t(`data.sheet.view.${v}`)}
        </button>
      ))}
    </div>
  );
}
